import { pathgen } from 'object-path-generator';
export const ProgressBarTestIds = pathgen('ProgressBarTestIds');